<template>
  <div class="response_table role_table">
    <table>
      <thead>
        <tr>
          <th scope="col"> {{translate("user.role_manage.role")}} </th>
          <th scope="col"> {{translate("user.role_manage.permissions")}} </th>
          <th scope="col" v-if="edit_rbac" > {{translate("user.role_manage.action")}} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(role, role_key) in role_list_sorted" :key="role_key" class="role">
          <td data-label="Name">
            <span>{{ role.name }}</span>
          </td>

          <td data-label="Permissions" class="permissions">
            <span
                v-for="(permission, permission_key) in role.permissions"
                :key="permission_key"
                :title="permission_list[permission].description"
            >
              {{ permission_key !== role.permissions.length -1 ? permission + ',' : permission }}
            </span>
          </td>

          <td data-label="action" v-if="edit_rbac">
            <span
                v-if="role.checked"
                class="action revoke btn btn-danger btn-wd"
                @click="revoke_role(role)"
            >
              {{ translate('btn.delete') }}
            </span>

            <span
                v-else
                class="action assign btn btn-success btn-wd"
                @click="assign_role(role)"
            >
              {{ translate('btn.add') }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: "TableRoles",
  props: ["user_id", "role_list", "permission_list"],
  data () {
    return {

    }
  },
  computed:{
    role_list_sorted(){
      return Object.values(this.role_list).sort((a, b) => a.name > b.name ? 1 : -1)
    },
    edit_rbac(){
      return this.$store.getters.getPermissions.editRbac === true
    }
  },
  methods: {
    assign_role(role){
      this.$http.v1.assignRoles({user_id: this.user_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_assign'))
        this.$emit("update")
      })
    },
    revoke_role(role){
      this.$http.v1.revokeRoles( {user_id: this.user_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_revoke'))
        this.$emit("update")
      })
    }
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: 100%;
  }
  .role_table{
    padding: 0;
    table{
      thead{
        flex:0;
      }
      tbody{
        .role{
          .permissions{
            max-height: 150px;
            display: block;
            overflow-y: auto;
          }
          .action{
            font-size: 14px;
            line-height: 100%;
            cursor: pointer;
            padding: 2px;
          }
        }
      }
    }
  }



</style>
